
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { getStockInoutTypeList } from '@/api/stock';
import DialogSetStaff from '../../staff/components/setStaff.vue';

@Component({
  name: "StockSearchItem",
  components: {
    DialogSetStaff
  },
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {},
  })
  searchData!: any;

  private typeOptions = [{
    value: '1',
    label: '入库',
    children: [{
      value: 0,
      label: '全部'
    }]
  }, {
    value: '2',
    label: '出库',
    children: [{
      value: 0,
      label: '全部'
    }]
  }]
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, start]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  
  created() {

  }

  private datePickChange(val:any){
    this.searchData.fields = val;
    this.changeData();
  }
  private cascaderSelect(val:any) {
    // this.formSearch.type = val[0];
    // this.formSearch.inout_type = val[1];
    this.searchData.fields = val;
    this.changeData();
  }
  private cascaderChange(val:any) {
    this.getStockInoutTypeList(val[0]);
  }
  private getStockInoutTypeList(type:any) {
    let _ = this;
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.type = type;
    getStockInoutTypeList(pamars).then((res:any) => {
      if (res.data && res.data.list) {
        if (parseInt(type) === 1) {
          _.typeOptions[0].children = [{
            value: 0,
            label: '全部'
          }];
          res.data.list.map(function(item:any) {
            _.typeOptions[0].children.push({
              value: item.id,
              label: item.name
            });
          });
        }
        if (parseInt(type) === 2) {
          _.typeOptions[1].children = [{
            value: 0,
            label: '全部'
          }];
          res.data.list.map(function(item:any) {
            _.typeOptions[1].children.push({
              value: item.id,
              label: item.name
            });
          });
        }
      }
    });
  }

  private dialogSelectStaffVisible = false;
  private radioSelectedStaff = true
  private selectedStaffHandle(val:any) {
    // this.formSearch.staff = val;
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }
  private closeStaff(val: any) {
    this.dialogSelectStaffVisible = val;
  }
  private staffReadonly = false;
  private clearStaff() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }
  @Watch('customerVisible')
  getCustomerVisible(val: boolean) {
    if (val) {
      this.staffReadonly = true;
    } else {
      this.staffReadonly = false;
    }
  }

  private changeData() {
    this.$emit("receiveData", this.searchData);
  }

  private keyupHandle() {
    this.$emit("receiveData", this.searchData, true);
  }
}
